import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/ui/base/tooltip';
import { cn } from '@/nucleo/utilitarios';

interface HeaderInfoRowProps {
  icon: LucideIcon;
  label: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

/** Linha do header do Fechamento Mensal V2 — rótulo-coluna fixo à esquerda
 * (com tooltip opcional), conteúdo livre à direita. */
export function HeaderInfoRow({ icon: Icon, label, description, children, className }: HeaderInfoRowProps) {
  const rotulo = (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground sm:w-24 sm:pt-0.5',
        description && 'cursor-help underline decoration-dotted decoration-muted-foreground/40 underline-offset-4',
      )}
    >
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </span>
  );

  return (
    <div
      className={cn(
        'flex flex-col gap-1.5 border-t border-border/40 pt-2 first:border-0 first:pt-0 sm:flex-row sm:items-baseline sm:gap-3 sm:border-0 sm:pt-0',
        className,
      )}
    >
      {description ? (
        <Tooltip>
          <TooltipTrigger asChild>{rotulo}</TooltipTrigger>
          <TooltipContent side="top" align="start" className="max-w-[260px] text-xs">
            {description}
          </TooltipContent>
        </Tooltip>
      ) : (
        rotulo
      )}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
